import React from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import ChevronLeftIcon from 'components/material-symbol/icons/ChevronLeft'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
  previousButton: {
    textTransform: 'none',
    fontWeight: 600,
    paddingLeft: 0,
    '& .MuiButton-startIcon': {
      marginRight: theme.spacing(0.5),
      marginLeft: 0,
    },
  },
  nextButton: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 24,
    padding: theme.spacing(1, 2.5),
    minWidth: 'auto',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },
}))

const EditEventPagination = ({
  isFirstStep,
  isLastStep,
  onPrevious,
  onNext,
  isNextDisabled = false,
}) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      {!isFirstStep ? (
        <Button
          type="button"
          color="primary"
          className={classes.previousButton}
          startIcon={<ChevronLeftIcon fontSize="small" />}
          onClick={onPrevious}
        >
          Previous
        </Button>
      ) : null}
      {!isLastStep ? (
        <Button
          type="button"
          variant="contained"
          color="primary"
          className={classes.nextButton}
          onClick={onNext}
          disabled={isNextDisabled}
        >
          Next
        </Button>
      ) : null}
    </Box>
  )
}

export default EditEventPagination
